import React, { useState } from "react";
import clsx from "clsx";
import {
	Container,
	Row,
	Col,
	Button,
	ButtonToolbar,
	ButtonGroup,
} from "reactstrap";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import { Link } from "react-router-dom";
import Image from "../../../components/Image";
const caseInfo = {
	source: "Shengwei Zhu",
};
export default function CommercialBus() {
	return (
		<TabPane tabId={"bus"}>
			<Row style={{ padding: 16 }}>
				<Col xs="12" sm={{ size: 12 }}>
					<h4>University Campus Bus</h4>
				</Col>
				<Col xs="12" sm={{ size: 12 }}>
					<p>
						The bus model was created according to a Daimler SLF 200 from
						Harvard University Shuttle Service.{" "}
						<strong>
							The bus is simulated with an occupancy of 26 people, a driver and
							25 passengers.
						</strong>{" "}
						This bus has six linear air supply diffusers located near the
						ceiling, including a two-slot diffuser supplying air downwards and a
						one-slot diffuser supplying air horizontally. The exhaust opening is
						placed in the ceiling close to the rear door. Air exchange rate was
						around 15 ACH in the simulation. A passenger sitting in the
						penultimate row by the aisle was assumed to be the source of
						COVID-19.{" "}
						<strong>
							The exhaled viruses were exhausted in 22 seconds, as the passenger
							was seated close to the air exhaust. However, according to the
							airpath and viral concentration distribution, if a person stands
							between the source and air exhaust, he/she would be exposed to a
							high risk.
						</strong>{" "}
						Furthermore, it is conceivable that a person standing around the
						outlet would have a high infection risk due to the low ceiling of
						the bus.
					</p>
					<p></p>
				</Col>
				<Col xs="12" sm={{ size: 10, offset: 1 }}>
					<Row>
						<Col xs={12} sm={6}>
							<h5 className="text-center">Case 1: Commercial Bus No Masks</h5>
							<figure className="figure">
								<Image src={`images/covid/buscase2-nomask-con.gif`} alt="" />
								<figcaption className="figure-caption">
									Animation of exhaled particles of infected occupant in Case 1.
									Animation duraction covers 30 seconds.
								</figcaption>
								<figcaption className="figure-caption">
									Source: City@UMD [{caseInfo.source}]
								</figcaption>
							</figure>
						</Col>
						<Col xs={12} sm={6}>
							<h5 className="text-center">Case 2: Commercial Bus with Masks</h5>
							<figure className="figure">
								<Image src={`images/covid/buscase2-mask-con.gif`} alt="" />
								<figcaption className="figure-caption">
									Animation of exhaled particles of occupant in Case 2 over 60
									minutes.
								</figcaption>
								<figcaption className="figure-caption">
									Source: City@UMD [{caseInfo.source}]
								</figcaption>
							</figure>
						</Col>
					</Row>
				</Col>
			</Row>
		</TabPane>
	);
}
